// extracted by mini-css-extract-plugin
export default {"pie":"Charts_pie__RQJU0"};